<template>
   <div class="main">
	<div class="submain">Zaloguj się do Systemu</div>
	<div class="row">
		<div id="ControlRegion"> 
			<form method="post" @submit.prevent="getAction()">
    			<div class="col-lg-6 control-section"> 
        			<div class="ee-input-group"> 
            				<input class="e-input" type="password" placeholder='Enter Password' autocomplete="current-password" required="" id="id_password"> 
            				<span class="e-icons e-input-eye" @click="showPassword()"></span> 
					<span class="errorpw">Błędny PIN i/lub hasło</span>
        			</div> 
    			</div>
			<div>
				<button class="button">Zaloguj</button>
			</div>
			</form>
		</div>
	</div>
    </div>
</template>


<script>

import { InputObject, TextBox } from  '@syncfusion/ej2-inputs';
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-calendars/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-popups/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
//import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";
import jwt_decode from "jwt-decode";

axios.defaults.withCredentials = false;

export default {
  name: "app",
  data: () => ({
	data: {},
	company_id: -1,
  }),
  components: {
	//'input': InputObject,
  },
  methods: {
	showPassword() { 
		const password = document.querySelector('#id_password');
    		// toggle the type attribute
    		const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    		password.setAttribute('type', type);
	},
	getAction() {
		console.log("trying to log in...");
		const password = document.querySelector('#id_password').value;
		//const password = '0192726a545c40c0a063a064819c66d8';
		//const password = 'admin';
		var that = this;
        	this.getData(password).then(response => {
			if (response.status != 200) {
				console.log("Incorrect login/password");
				Storage.cleanJWT().then(resp => {
					document.querySelector('.errorpw').style.display = "block";
				});
			} else {
				console.log("Login successfull.");
				document.querySelector('.errorpw').style.display = "none";
                		that.data = response.data;
				Storage.saveJWT("jwt", that.data).then(resp => {
					//alert(JSON.stringify(resp));
					// Parse JWT Token and decide where route to
					var decoded = jwt_decode(resp.access_token);
                			//alert(JSON.stringify(decoded));
					if (decoded != null && (decoded.role && decoded.role === 'admin') || (decoded.claims && decoded.claims === 'galek.magazyn.Admin_panel')) {
					  this.$router.push({ path: "/paneladmin" });
					} else {
					  this.$router.push({ path: "/main" });
					}
				});
			}
        	});
	},
	getData(password) {
		//const token = { "token": password };
		const token = { "company_id": this.company_id, "pin": password };
		//const token = { "username": "admin@polskagrupa.it", "password": password };
                return axios
                        .post(CONFIG.API_LOGIN, token, {
                        headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                        }
                        })
                        .then(response => {
                                return response;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
  },
  mounted() {
	//const CompanyID = `${process.env.VUE_COMPANY_ID}`;
	this.company_id = CONFIG.COMPANY_ID;
	console.log("Company ID:" + this.company_id);
  }
}


</script>

<style> 

.errorpw { 
	color: red;
	display: none;
}
   #id_password {
	width: 160px;
	height: 40px;
	text-align: center;
	position:relative;
   }
   .main {
	margin-top: 50px;
   }
   .submain { 
	margin-bottom: 40px;
   }
   .button {
	color: #FFFFFF;
        background-color: green;
	width: 200px;
	height: 40px;
   }

   .e-input-group {
	width: 200px;
	height: 30px;
    }
   .e-input-eye:after { 
        content:'\e345'; 
        font-family: e-icons; 
        font-size: 20px; 
	display: inline;
	vertical-align: middle;
	padding-top: 10px;
	color: black;
    } 
</style> 



// WEBPACK FOOTER //
// src/components/LoginContent.vue